<template>
  <svg viewBox="0 0 1078 384" xmlns="http://www.w3.org/2000/svg">
    <path id="item-line0"  class="cls-1 fix-svg-origin animated zoomIn" d="M839 141s-47.28-48.12-130.42-31.38c0 0-123.47 22.1-166.28-27.12H539c-48.9 46.88-166.28 27.12-166.28 27.12C289.61 92.88 242.33 141 242.33 141" fill="none" stroke="#ffe300" stroke-miterlimit="10"/>
    <g id="boton0">
      <text x="432.81" y="62.75" fill="#beeb7b" font-family="helveticaNeueCn, HelveticaLTStd-BoldCond,Helvetica LT Std" font-size="22" font-weight="700">
        Métodos probabilísticos
      </text>
      <path fill="none" stroke="#beeb7b" stroke-miterlimit="10" d="M406.66 30.75h268v51h-268z"/>
    </g>
    <g id="boton2" class="fix-svg-origin hvr hvr-clr animated zoomIn" v-ripple @click="$set(vistos,1,true)">
      <text class="cls-4" x="785.22" y="172" fill="#fff" font-family="helveticaNeueCn, HelveticaLTStd-BoldCond, 'Helvetica LT Std'" font-size="22" font-weight="700">
        Debilidades
      </text>
      <path class="cls-5" fill="none" stroke="#fff" stroke-miterlimit="10" d="M768.5 143.5h141v44h-141z"/>
    </g>
    <path id="item-line1" v-if="vistos[0]" class="cls-1 fix-svg-origin animated zoomIn" fill="none" stroke="#ffe300" stroke-miterlimit="10" d="M54.75 324.5v-120H239.5v-17"/>
    <text id="texto1" v-if="vistos[0]" class="cls-6 animated fadeInLeft dura-2" x="78" y="252.61" fill="#fff" font-family="helveticaNeueCn, HelveticaLTStd-Cond, 'Helvetica LT Std'" font-size="22">
      Puede utilizarse desde la etapa de <tspan x="78" y="277.61">exploración hasta la de producción.</tspan>
    </text>
    <g id="item1" v-if="vistos[0]" class="animated zoomIn dura-1">
      <circle class="cls-7" cx="55.38" cy="245.11" r="15.13" fill="#121a26" stroke="#ffe300" stroke-miterlimit="10"/>
      <path class="cls-8" fill="none" stroke="#5b9b00" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M47.5 246.2l6 7.41 11-15"/>
    </g>
    <text id="texto2" v-if="vistos[0]" class="cls-6 animated fadeInLeft dura-2" x="78" y="329.61" fill="#fff" font-family="helveticaNeueCn, HelveticaLTStd-Cond, 'Helvetica LT Std'" font-size="22">
      Se puede obtener múltiples escenarios.
    </text>
    <g id="item2" v-if="vistos[0]" class="animated zoomIn dura-1">
      <circle class="cls-7" cx="55.38" cy="321.91" r="15.13" fill="#121a26" stroke="#ffe300" stroke-miterlimit="10"/>
      <path class="cls-8" fill="none" stroke="#5b9b00" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M47.5 323l6 7.41 11-15"/>
    </g>
    <path id="item-line2" v-if="vistos[1]" class="cls-1 fix-svg-origin animated zoomIn" fill="none" stroke="#ffe300" stroke-miterlimit="10" d="M653.75 321V204.5H838.5v-17"/>
    <text id="texto3" v-if="vistos[1]" class="cls-6 animated fadeInLeft dura-2" x="678" y="252.61" fill="#fff" font-family="helveticaNeueCn, HelveticaLTStd-Cond, 'Helvetica LT Std'" font-size="22">
      Pueden resultar cálculos extensos, <tspan x="678" y="277.61">complicados e ineficientes.</tspan>
    </text>
    <text id="texto4" v-if="vistos[1]" class="cls-6 animated fadeInLeft dura-2" x="678" y="329.61" fill="#fff" font-family="helveticaNeueCn, HelveticaLTStd-Cond, 'Helvetica LT Std'" font-size="22">
      La dependencia entre parámetros del <tspan x="678" y="354.61">yacimiento hace más difícil su evaluación.</tspan>
    </text>
    <g id="item3" v-if="vistos[1]" class="animated zoomIn dura-1">
      <circle class="cls-7" cx="654.38" cy="245.11" r="15.13" fill="#121a26" stroke="#ffe300" stroke-miterlimit="10"/>
      <path class="cls-8" fill="none" stroke="#5b9b00" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M646.5 246.2l6 7.41 11-15"/>
    </g>
    <g id="item4" v-if="vistos[1]" class="animated zoomIn dura-1">
      <circle class="cls-7" cx="654.38" cy="321.91" r="15.13" fill="#121a26" stroke="#ffe300" stroke-miterlimit="10"/>
      <path class="cls-8" fill="none" stroke="#5b9b00" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M646.5 323l6 7.41 11-15"/>
    </g>
    <g id="boton1" class="fix-svg-origin hvr hvr-clr animated zoomIn" v-ripple @click="$set(vistos,0,true)">
      <text class="cls-4" x="194.56" y="172" fill="#fff" font-family="helveticaNeueCn, HelveticaLTStd-BoldCond, 'Helvetica LT Std'" font-size="22" font-weight="700">
        Fortalezas
      </text>
      <path class="cls-5" fill="none" stroke="#fff" stroke-miterlimit="10" d="M170.5 143.5h141v44h-141z"/>
    </g>
</svg>
</template>
<script>
export default {
  data() {
    return {
      vistos: [false, false]
    }
  },
  watch: {
    vistos: function(newValue){
      var todosVistos = newValue.every(el => {return el})
      if(todosVistos){
        this.$emit('finished')
      }
    }
  }
}
</script>
<style scoped>
  #item-line0{
    transform-origin: 300px 0px;
  }
  #item-line1{
    transform-origin: 200px 0;
  }
  #item-line2{
    transform-origin: 250px 0px;
  }
  #item5, #item6 {
    transform-origin: 650px 0;
  }
  .hvr-clr:hover .cls-5{
    fill: rgba(255,255,255,0.1) !important;
  }
  .cls-1,.cls-5,.cls-8{fill:transparent}.cls-1,.cls-7{stroke:#ffe300}.cls-1,.cls-5,.cls-7{stroke-miterlimit:10}.cls-4,.cls-6{font-size:22px}.cls-4{font-family:helveticaNeueCn, HelveticaLTStd-BoldCond,Helvetica LT Std;font-weight:700}.cls-4,.cls-6{fill:#fff}.cls-5{stroke:#fff}.cls-6{font-family:helveticaNeueCn, HelveticaLTStd-Cond,Helvetica LT Std}.cls-7{fill:#121a26}.cls-8{stroke:#5b9b00;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px}
</style>